import Rx from 'rxjs';

export default class AdminService {
  constructor($http, host) {
    this.http = $http;
    this.host = host;
  }

  retrieveAllAccounts(){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  viewAccount(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts/${account.id}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  toggleAccountStatus(account) {
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/admin/accounts/${account.id}`
    }).then(
      resp => resp.data,
      resp => {}
    ));
  }

  getClientKeys(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts/client-ids/${account.id}`
    }).then(
      resp => resp.data.client_ids,
      resp => []
    ));
  }

  generateClientKey(account) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/admin/accounts/client-ids/${account.id}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  removeClientKey(account, clientKey) {
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/admin/accounts/client-ids/${account.id}`,
      params: {client_id: clientKey}
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getAccountProfiles(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts/profiles/${account.id}`
    }).then(
      resp => resp.data.profiles,
      resp => resp
    ));
  }

  getAccountPointsOfSale(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts/points-of-sale`,
      params: {
        account_id: account.id
      }
    }).then(
      resp => resp.data.points_of_sales,
      resp => resp
    ));
  }

  registerPOS(pos, account){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/admin/accounts/points-of-sale`,
      data: angular.extend(pos, {account_id: account.id})
    }).then(
      (resp) => { return resp.data; }
    ));
  }

  changePOS(pos, account){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/admin/accounts/points-of-sale/${pos.id}`,
      data: angular.extend(pos, {account_id: account.id})
    }));
  }

  deletePOS(pos, account){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/admin/accounts/points-of-sale/${pos.id}`,
      params: {account_id: account.id}
    }));
  }

  

  registerCollector(){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/admin/collectors`,
      data: {}
    }).then(
      resp => resp.data,
      resp => resp
    ));
  };

  associateCollector(cid, aid){
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/admin/collectors/${cid}`,
      data: {
        account_id: aid
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  };

  disassociateCollector(cid, aid){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/admin/collectors/${cid}`,
      data: {
        account_id: aid
      }
    }).then(
      resp => resp.data,
      resp => resp
    ))
  }

  getAllCollectors(aid){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/collectors`,
      params: {
        account_id: aid
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  };

  deleteCollector(cid){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/admin/collectors/${cid}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  observePOS(collector, pos, account){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/admin/accounts/collectors/${collector.id}/pos`,
      data: {
        pos_id: pos.id,
        account_id: account.id
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  unobservePOS(collector, pos, account){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/admin/accounts/collectors/${collector.id}/pos/${pos.id}`,
      params: {
        account_id: account.id        
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getAccountBackups(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts/backups`,
      params: {
        account_id: account.id
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getAccountDTTs(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/admin/accounts/dtts`,
      params: {
        account_id: account.id
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  processDTTs(account){
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/admin/accounts/dtts`,
      data: {
        account_id: account.id
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));

  }

}

 AdminService.$inject = ['$http', 'host'];



// WEBPACK FOOTER //
// ./src/app/services/admin.service.js